import { render, staticRenderFns } from "./SelfAssessmentStaff.vue?vue&type=template&id=05daf2fa&scoped=true&"
import script from "./SelfAssessmentStaff.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentStaff.vue?vue&type=script&lang=js&"
import style0 from "./SelfAssessmentStaff.vue?vue&type=style&index=0&id=05daf2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05daf2fa",
  null
  
)

export default component.exports